module.exports = new __parcel__URL__("cleanroom.c41dfe7f.jpg").toString();